<ng-container *ngIf="navegacao.emAndamento()">
  <div class="navegacao-barra" aria-hidden="true">
    <span class="navegacao-barra__progresso"></span>
  </div>

  <div class="navegacao-carga-inicial" *ngIf="!navegacao.primeiraCargaConcluida()">
    <app-carregando mensagem="Carregando..."></app-carregando>
  </div>
</ng-container>
